
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/easyx",
      function () {
        return require("private-next-pages/easyx/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/easyx"])
      });
    }
  